var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 7.138h21.24c.761 0 1.38-.613 1.38-1.368a1.36 1.36 0 0 0-.233-.759L20.933.796A1.796 1.796 0 0 0 19.436 0H4.564a1.8 1.8 0 0 0-1.497.796L.232 5.008c-.15.226-.232.49-.232.758 0 .759.619 1.372 1.38 1.372zm1.02 1.19v8.922c0 .985.806 1.784 1.8 1.784h8.4c.994 0 1.8-.799 1.8-1.784V8.328H12v5.948H4.8V8.328H2.4zm16.8 0v9.517c0 .658.536 1.19 1.2 1.19.664 0 1.2-.532 1.2-1.19V8.328h-2.4z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStore);
export default __webpack_public_path__ + "static/media/my-store.e4d45402426afa6e445db594e6af1bb6.svg";
export { ForwardRef as ReactComponent };